export default __webpack_public_path__ + "static/media/m_headerImage.b4c9c089.avif";